import * as z from "zod";
import {
  coverageArmMetricView,
  coverageSplitArmIdentity,
  coverageSplitHeader,
} from "./get-coverage-arm-metrics";

const coverageArmLatestMetrics = coverageArmMetricView.omit({
  dailyTrend: true,
});

export const listCoverageSplitSummaries = {
  name: "listCoverageSplitSummaries" as const,
  input: z.object({}),
  output: z.object({
    splits: z.array(
      z.object({
        split: coverageSplitHeader,
        arms: z.array(
          coverageSplitArmIdentity.extend({
            metrics: coverageArmLatestMetrics.nullable(),
          }),
        ),
      }),
    ),
  }),
};
